<script>
    // @ts-nocheck
    import {onMount} from 'svelte';
    import {t, teile} from '$utils/lang.js';
    import {getLocale} from '$m7-library/utils/i18n.js';
    import {scrollToFirstError} from '$utils/scrollToError.js';
    import {store as userStore, fetchUser, validateVatId} from '$lib/userStore.svelte.js';
    import {paymentStore, fetchShippingAndPayment, handleGatewayApproved, resetGatewayApproved, selectPayment, cancelStripeExpress} from '$lib/paymentStore.svelte.js';
    import {store as basketStore, refreshBasket} from '$lib/basketStore.svelte.js';
    import {addressRejection} from '$lib/addressRejection.svelte.js';
    import {buttonStyles} from '$m7-library/main';
    import {trackPurchase} from '$lib/tracking.js';
    import {PHONE_REGEX} from '$component/PhoneSection.svelte';
    import PhoneSection from '$component/PhoneSection.svelte';
    import ReviewHeadline from '$component/ReviewHeadline.svelte';
    import PaypalGateway from '$component/Payments/PaypalGateway.svelte';
    import PaypalAcdc from '$component/Payments/PaypalAcdc.svelte';
    import PaypalPui from '$component/Payments/PaypalPui.svelte';
    import AmazonPay from '$component/Payments/AmazonPay.svelte';
    import StripePayment from '$component/Payments/StripePayment.svelte';
    import EuGuaranteeNotice from '$component/EuGuaranteeNotice.svelte';

    const {
        status = 'active',
        onContinue = () => {},
        onBack = () => {},
        // Gefeuert, wenn der easyCredit-Vorgang nicht mehr zum Warenkorb passt.
        // Checkout.svelte zeigt daraufhin ein Top-Level-Banner — paymentStore.error
        // wäre beim Aktivieren des Payment-Steps sofort wieder überschrieben.
        onEasyCreditStale = () => {},
    } = $props();

    let placing = $state(false);
    let placeError = $state('');
    let stepEl = $state(); // active-step root — anchor for shadow-DOM error scroll
    // PayPal Express PAYER_ACTION_REQUIRED (#49): the backend's payer-action
    // link. When set, a re-approval button is shown instead of a dead-end
    // error. Clicking it opens PayPal's hosted approval page for the SAME
    // (amount-patched) order; placeOrder is retried only after the buyer
    // closes that window — never automatically.
    let payerActionUrl = $state('');
    // PayPal Express amount-mismatch fallback (#50): set after the backend
    // swaps the session payment to m7_paypal; shows a banner above the standard
    // PayPal button that now renders (selectedPaymentId = m7_paypal).
    let paypalAmountFallback = $state(false);

    const user = $derived(userStore.user);
    const hideShipping = $derived(user.hideShipping);
    const billing = $derived(user.billingAddress);
    const shipping = $derived(user.shippingAddress);
    const isPackstation = $derived(shipping.street === 'Packstation');

    const shippingMethods = $derived(paymentStore.shippingMethods ?? []);
    const paymentMethods = $derived(paymentStore.paymentMethods ?? []);
    const selectedShippingId = $derived(paymentStore.selectedShippingId);
    const selectedPaymentId = $derived(paymentStore.selectedPaymentId);
    const selectedShipping = $derived(
        shippingMethods.find(s => s.shippingSet?.id === selectedShippingId)
    );
    const selectedPayment = $derived(
        paymentMethods.find(p => p.id === selectedPaymentId)
    );

    const isLeasing = $derived(selectedPayment?.type === 'LEASING');
    const leasingFormLines = $derived(selectedPayment?.metadata?.formLines ?? []);
    const isPaypalGateway = $derived(selectedPayment?.metadata?.sdk === 'paypal-gateway');
    const isPaypalAcdc = $derived(selectedPayment?.metadata?.sdk === 'paypal-acdc');
    const isPaypalPui = $derived(selectedPayment?.metadata?.sdk === 'paypal-pui');
    const isAmazonPay = $derived(selectedPayment?.metadata?.sdk === 'amazon-pay');
    const isAmazonPayExpress = $derived(selectedPayment?.metadata?.sdk === 'amazon-pay-express');
    const isEasyCredit = $derived(selectedPayment?.metadata?.sdk === 'easycredit');
    const isStripe = $derived(selectedPayment?.metadata?.sdk === 'stripe');
    let acdcApi = $state(null);
    let puiBirthdate = $state('');
    let puiPhone = $state('');
    let puiCmid = $state('');
    let puiReinitKey = $state(0);
    $effect(() => { if (!isPaypalPui) { puiBirthdate = ''; puiPhone = ''; puiCmid = ''; puiReinitKey = 0; } });

    const requiresPhoneForOrder = $derived(!!selectedShipping?.shippingSet?.requiresPhone);
    const userPhone = $derived(
        userStore.user?.billingAddress?.phone
        ?? userStore.user?.shippingAddress?.phone
        ?? ''
    );
    const phoneMissingForOrder = $derived(requiresPhoneForOrder && !PHONE_REGEX.test(userPhone));

    let phoneState = $state({requiresPhone: false, phone: '', phoneOk: true});
    let vatConfirmed = $state(false);
    const vatBlocked = $derived(userStore.vatValidationResult?.taxInfo === 2 || userStore.vatValidationResult?.taxInfo === 3);
    // PhoneSection only renders inside {#if phoneMissingForOrder} and mutates
    // phoneState via onchange. When userPhone settles to a valid number the
    // section unmounts, leaving phoneState orphaned at its last emitted value
    // (phoneOk:false from its brief empty-mount) — which would wedge canOrder
    // false forever. Gate on phoneState ONLY while the section is mounted;
    // otherwise the phone requirement is already satisfied by userPhone.
    const effectivePhoneOk = $derived(phoneMissingForOrder ? phoneState.phoneOk : true);
    const canOrder = $derived(!placing && effectivePhoneOk && (!isPaypalPui || (!!puiBirthdate && !!puiPhone && !!puiCmid)) && (!vatBlocked || vatConfirmed));

    import {currencyFormatter} from '$utils/formatter.js';
    import {items as basketItems, totalSavings as basketTotalSavings} from '$lib/basketStore.svelte.js';

    // Shared Figma card styles (Review-Step redesign, node 419:57).
    const cardClass = 'bg-white border border-[#e5e7eb] rounded-[10px] shadow-sm p-5 flex flex-col gap-3';
    const cardTitleClass = 'font-bold text-[17px] leading-6 text-[#0a0a0a]';
    const editLinkClass = 'font-bold text-xsm text-elm underline cursor-pointer whitespace-nowrap py-2 -my-2';
    const cardBodyClass = 'flex flex-col gap-0.5 text-xsm text-[#4a5565]';
    // Buy-CTA: teal→elm gradient with lock icon (Figma node 419:106).
    // NB: from-0%/to-100% are required — without explicit gradient stop
    // positions Tailwind v4 emits no background-image here (renders transparent).
    const buyBtnClass = 'w-full flex items-center justify-center gap-2.5 rounded-[10px] p-3.5 font-black text-base text-white bg-linear-to-b from-teal from-0% to-100% to-elm shadow-[0_4px_6px_rgba(0,46,64,0.25)] cursor-pointer transition hover:brightness-105';

    // Produkttitel enthalten teils rohe HTML-Entities (z.B. 29&quot;). Als
    // Text ausgegeben würden sie wörtlich erscheinen → hier dekodieren.
    const decodeEntities = (s) => (s ?? '')
        .replace(/&quot;/g, '"').replace(/&#0?34;/g, '"')
        .replace(/&#0?39;/g, "'").replace(/&apos;/g, "'")
        .replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');

    async function handlePaypalGatewayApproved() {
        handleGatewayApproved();
        await handlePlaceOrder();
        if (placeError) resetGatewayApproved();
    }

    async function handleStripeApproved() {
        handleGatewayApproved();
        await handlePlaceOrder();
        if (placeError) resetGatewayApproved();
    }

    async function handlePaypalAcdcApproved() {
        handleGatewayApproved();
        await handlePlaceOrder();
        if (placeError) resetGatewayApproved();
    }

    // PayPal Express re-approval (#49). The Express order now carries
    // return_url=...&paypalReady=express, so we redirect the buyer to PayPal's
    // hosted approval page for the amount-patched order. After they approve,
    // PayPal returns to ?paypalReady=express and the return handler (onMount)
    // retries placeOrder → capture → thank-you. A full-page redirect (not
    // window.open) is never popup-blocked.
    function handlePayerActionClick() {
        if (payerActionUrl) window.location.href = payerActionUrl;
    }

    $effect(() => {
        if (isPaypalGateway || isPaypalAcdc || isAmazonPay || isEasyCredit || isStripe) placeError = '';
    });

    // easyCredit-Wache: der Review-Step darf mit einem wertlosen Vorgang gar
    // nicht angezeigt werden.
    //
    // Ein freigegebener Vorgang hat immer Zinsen > 0. Fallen die weg, während
    // easyCredit gewählt ist, stimmt der Vorgang nicht mehr zum Warenkorb —
    // der Proxy liefert easyCreditInterests dann bewusst null (Abgleich gegen
    // m7_ec_initAmount). Ohne diese Wache stünde hier eine Summe mit falschen
    // Zinsen und ein "Jetzt kaufen", das der Riegel in Order::finalizeOrder()
    // zwangsläufig abweist — der Kunde würde erst nach dem Klick erfahren,
    // dass er zurück muss. Also sofort zurück in den Payment-Step, wo die
    // erneute easyCredit-Wahl einen Vorgang über den aktuellen Betrag anlegt.
    let ecGuardFired = $state(false);
    $effect(() => {
        if (status !== 'active' || !isEasyCredit) {
            ecGuardFired = false;
            return;
        }
        // basketStore.loading abwarten: während des Refetch ist der Wert
        // kurzzeitig false, das ist kein Mismatch.
        if (basketStore.loading) return;
        // easyCreditReady statt easyCreditInterests: Rechnungskauf hat keine
        // Zinsen, mit dem alten Signal würde die Wache dort bei JEDER Bestellung
        // feuern. Der Proxy setzt ready auf false, sobald der Vorgang nicht mehr
        // zum Warenkorb passt (isEcVorgangStale) — deckt beide Produkte ab.
        if (basketStore.easyCreditReady) return;
        if (ecGuardFired) return;
        ecGuardFired = true;
        devLog('ecGuard:stale-vorgang → back to payment', {
            paymentId: selectedPayment?.id ?? null,
            ready: basketStore.easyCreditReady,
            interests: basketStore.easyCreditInterests,
            total: basketStore.snapshot?.total?.brutto ?? null,
        });
        paymentStore.selectedPaymentId = null;
        resetGatewayApproved();
        placeError = '';
        onEasyCreditStale();
        onBack('payment');
    });

    import { devLog as _devLog } from '$utils/devLog.js';
    const devLog = (tag, ...args) => _devLog(`Order:${tag}`, ...args);

    // decision: [2]
    let vatNachgeholt = false;
    $effect(() => {
        if (status !== 'active' || vatNachgeholt || userStore.vatValidationResult) return;
        const b = userStore.user?.billingAddress;
        if (!b?.ustid || !b?.countryId) return;
        vatNachgeholt = true;
        validateVatId();
    });

    onMount(() => {
        devLog('mount', {
            shippingMethodCount: paymentStore.shippingMethods.length,
            selectedShippingId: paymentStore.selectedShippingId,
            selectedPaymentId: paymentStore.selectedPaymentId,
            shippingMethods: paymentStore.shippingMethods.map(s => s.shippingSet?.id),
            selectedShipping: selectedShipping?.shippingSet?.id ?? null,
        });
        if (status === 'active') {
            if (!userStore.user.billingAddress.name) fetchUser();
            if (paymentStore.shippingMethods.length === 0) fetchShippingAndPayment();
            // Server-side snapshot log for drift-checking against proxy +
            // placeOrder snapshots. Fire-and-forget, no error handling.
            fetch(`/index.php?cl=m7-checkout-doc&fnc=logReviewSnapshot`, {
                method: 'POST',
                credentials: 'same-origin',
            }).catch(() => {});
            const urlParams = new URLSearchParams(window.location.search);
            const amazonReady = urlParams.get('amazonReady');
            if (amazonReady) {
                history.replaceState(null, '', window.location.pathname + window.location.hash);
                handleGatewayApproved();
                // Standard: auto-place. Express: user clicks "Jetzt kaufen" manually.
                if (amazonReady === '1') handlePlaceOrder();
            }

            // Stripe redirect return (Przelewy24, Klarna): Stripe appends payment_intent and redirect_status.
            // reference: [StripePayment 1]
            if (urlParams.get('stripeReady')) {
                const redirectStatus = urlParams.get('redirect_status');
                history.replaceState(null, '', window.location.pathname + window.location.hash);
                if (redirectStatus === 'succeeded' || redirectStatus === 'processing') {
                    handleGatewayApproved();
                    handlePlaceOrder();
                } else {
                    placeError = t('Die Zahlung wurde nicht abgeschlossen. Bitte versuche es erneut oder wähle eine andere Zahlungsart.');
                }
            }

            // PayPal Express re-approval return (#49): the buyer came back from
            // the payer-action page. paypalCanceled=1 → they aborted (show error,
            // no retry); otherwise they re-approved → retry placeOrder → capture.
            const paypalReady = urlParams.get('paypalReady');
            if (paypalReady === 'express') {
                history.replaceState(null, '', window.location.pathname + window.location.hash);
                if (urlParams.get('paypalCanceled') === '1') {
                    placeError = t('Du hast die PayPal-Zahlung abgebrochen. Bitte bestätige sie erneut, um deinen Kauf abzuschließen.');
                } else {
                    handleGatewayApproved();
                    handlePlaceOrder();
                }
            }
        }
    });

    async function savePuiDataToSession(birthdate, phone, cmid) {
        const params = new URLSearchParams({cl: 'm7-checkout-dpc', fnc: 'savePuiData'});
        await fetch(`/index.php?${params}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({birthdate, phone, cmid}),
        });
    }

    async function handlePlaceOrder() {
        devLog('btn:placeOrder', {
            canOrder,
            phone: phoneState.phone || null,
            selectedShippingId: paymentStore.selectedShippingId,
            selectedPaymentId: paymentStore.selectedPaymentId,
            billingCity: billing?.city,
            billingPhone: billing?.phone || null,
            shippingCity: shipping?.city,
        });
        if (!canOrder) {
            scrollToFirstError(stepEl);
            return;
        }
        if (isPaypalPui && puiBirthdate && puiPhone) {
            await savePuiDataToSession(puiBirthdate, puiPhone, puiCmid);
        }
        placing = true;
        placeError = '';
        payerActionUrl = '';
        paypalAmountFallback = false;
        try {
            const params = new URLSearchParams({cl: 'm7-checkout-doc', fnc: 'placeOrder'});
            const response = await fetch(`/index.php?${params}`, {
                method: 'POST',
                credentials: 'include',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({phone: phoneState.phone}),
            });
            const data = await response.json().catch(() => ({}));
            devLog('placeOrder:result', {status: response.status, success: data.success, orderId: data.orderId, redirectUrl: data.redirectUrl, message: data.message, payerActionUrl: data.payerActionUrl ?? null, keys: Object.keys(data)});
            if (data.success) {
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else {
                    // In-app completion: fire GA4 purchase here. (Gateway
                    // redirects fire it server-side on the OXID thank-you page.)
                    trackPurchase(data.tracking);
                    onContinue(data.orderId, data.isLeasing);
                }
            } else if (data.code === 'ADDRESS_INCOMPLETE') {
                // reference: [DynamicOrderController 3]
                addressRejection.message = data.message || '';
                await fetchUser().catch(() => {});
                onBack('user');
            } else {
                // PayPal Express amount-mismatch fallback (#50): when the total
                // drifted after the Express approve, the backend discards the
                // locked order and swaps the session payment to the express
                // metadata's amountMismatchFallback (m7_paypal). Refetch so
                // selectedPaymentId reflects the swap → Order renders the
                // standard PayPal button; show a banner. Preferred over the
                // #49 re-approval popup for the mismatch case.
                // easyCredit-Betragsabweichung: der Vorgang ist serverseitig
                // schon verworfen (Order::finalizeOrder) und lässt sich nicht
                // nachträglich erhöhen. Auf dem Review-Step stehenzubleiben
                // hieße: rote Meldung plus ein Kaufen-Button, der garantiert
                // wieder scheitert. Also zurück in den Payment-Step, wo die
                // erneute easyCredit-Wahl einen frischen Vorgang über den
                // aktuellen Betrag anlegt. Gleiches Muster wie Amazon Pay.
                // Letztes Netz. Regulär soll der Kunde diesen Zustand nie
                // erreichen: ecGuard() unten schickt ihn schon beim Betreten
                // des Review-Steps zurück, damit "Jetzt kaufen" mit einem
                // wertlosen Vorgang gar nicht angeboten wird.
                if (data.errorCode === 'ec_basket_changed') {
                    devLog('placeOrder:ec_basket_changed → back to payment');
                    paymentStore.selectedPaymentId = null;
                    resetGatewayApproved();
                    placeError = '';
                    // Reihenfolge: erst Basket (die Zinszeile muss weg, sonst
                    // zeigt die Summe noch die Zinsen des verworfenen
                    // Vorgangs), dann die Zahlungsarten-Liste.
                    await refreshBasket();
                    await fetchShippingAndPayment();
                    // paymentStore.error ZULETZT: fetchShippingAndPayment()
                    // setzt store.error selbst auf null (paymentStore:193).
                    // Vorher gesetzt wäre der Hinweis wieder weg und der Kunde
                    // stünde ohne Erklärung im Payment-Step.
                    paymentStore.error = data.message
                        || t('Dein Warenkorb hat sich geändert. Bitte starte easyCredit erneut.');
                    onBack('payment');
                    return;
                }

                // Stripe wallet express: the reservation does not cover the order (or was released). Fall back to the normal
                // card payment, which asks for the card with the current amount.
                if (selectedPayment?.metadata?.sdk === 'stripe-express') {
                    await cancelStripeExpress('order_failed');
                    await selectPayment(selectedPayment.metadata.amountMismatchFallback);
                    placeError = t('Der Betrag hat sich geändert. Bitte bestätige die Zahlung mit deiner Karte erneut.');
                    return;
                }

                const fallbackTarget = selectedPayment?.metadata?.amountMismatchFallback;
                if (fallbackTarget === 'm7_paypal') {
                    await fetchShippingAndPayment();
                    if (paymentStore.selectedPaymentId === fallbackTarget) {
                        // Express set gatewayApproved=true; clear it so the
                        // standard PayPal button (gated on !gatewayApproved)
                        // renders for the fresh approval.
                        resetGatewayApproved();
                        paypalAmountFallback = true;
                        placeError = '';
                        return;
                    }
                }
                // PayPal Express amount-patch re-approval (#49): the backend
                // returns a payer-action link when PayPal needs the buyer to
                // re-confirm the patched amount. Show a re-approval button
                // (opens PayPal on click) instead of a dead-end error.
                if (data.payerActionUrl) {
                    payerActionUrl = data.payerActionUrl;
                    placeError = '';
                } else {
                    // ACDC (credit card) has no PayPal button on the page, so the
                    // backend's generic "click the PayPal button again" notApproved
                    // text is misleading. Show a card-specific hint instead.
                    placeError = isPaypalAcdc
                        ? t('Kartenzahlung konnte nicht bestätigt werden. Bitte prüfe deine Kartendaten (Ablaufdatum und Sicherheitscode) und versuche es erneut.')
                        : (data.message || t('Fehler beim Bestellen.'));
                    if (isPaypalPui) puiReinitKey++;
                    if (isAmazonPay || isAmazonPayExpress) {
                        paymentStore.error = placeError;
                        paymentStore.selectedPaymentId = null;
                        await fetchShippingAndPayment();
                        onBack('payment');
                    } else {
                        scrollToFirstError(stepEl);
                    }
                }
            }
        } catch (e) {
            devLog('placeOrder:error', {error: e.message});
            placeError = t('Netzwerkfehler. Bitte versuche es erneut.');
            scrollToFirstError(stepEl);
        } finally {
            placing = false;
        }
    }
</script>

{#if status === 'upcoming'}
    <!-- Locked upcoming state -->
    <div class="bg-white rounded-md border border-grey px-5.5 py-4 flex items-center gap-3" data-checkout-step="order" data-checkout-state="upcoming">
        <div class="bg-gray-100 text-gray-103 rounded-full size-7.5 flex items-center justify-center shrink-0">
            <span class="font-bold text-sm">3</span>
        </div>
        <span class="font-bold text-base text-gray-103">{t('Überprüfen & Kaufen')}</span>
    </div>
{:else}
    <!-- Active state (Figma Review-Step redesign, node 419:57) -->
    <div class="flex flex-col gap-6" data-checkout-step="order" data-checkout-section="step-review" data-checkout-state="expanded" bind:this={stepEl}>

        <!-- Headline block (desktop only; mobile renders it above the summary in Checkout.svelte) -->
        <ReviewHeadline class="hidden lg:flex" />

        {#if hideShipping}
            <!-- Combined delivery + billing card -->
            <div class={cardClass} data-checkout-section="address-combined">
                <div class="flex items-center justify-between gap-2">
                    <span class={cardTitleClass}>{t('Liefer- und Rechnungsadresse')}</span>
                    <button class={editLinkClass} onclick={() => onBack('user')} type="button" data-checkout-action="edit-address">{t('Bearbeiten')}</button>
                </div>
                <div class={cardBodyClass}>
                    {#if billing.company}<span>{billing.company}{#if billing.ustid}&nbsp;({billing.ustid}){/if}</span>{/if}
                    <span>{billing.name}</span>
                    <span>{billing.street} {billing.streetNo}</span>
                    {#if billing.addInfo && billing.addInfo !== billing.company}<span>{billing.addInfo}</span>{/if}
                    <span>{billing.zip} {billing.city}</span>
                    {#if billing.country}<span>{billing.country}</span>{/if}
                </div>
            </div>
        {:else}
            <!-- Separate delivery address -->
            <div class={cardClass} data-checkout-section="address-shipping">
                <div class="flex items-center justify-between gap-2">
                    <span class={cardTitleClass}>{t('Lieferadresse')}</span>
                    <button class={editLinkClass} onclick={() => onBack('user')} type="button" data-checkout-action="edit-shipping">{t('Bearbeiten')}</button>
                </div>
                <div class={cardBodyClass}>
                    {#if isPackstation}
                        <span>Packstation {shipping.streetNo}</span>
                        {#if shipping.packstationStreet}<span>{shipping.packstationStreet}</span>{/if}
                        <span>{shipping.zip} {shipping.city}</span>
                        {#if shipping.addInfo}<span>{t("Postnummer: {nummer}", {nummer: shipping.addInfo})}</span>{/if}
                    {:else}
                        {#if shipping.company}<span>{shipping.company}{#if shipping.ustid}&nbsp;({shipping.ustid}){/if}</span>{/if}
                        <span>{shipping.name}</span>
                        <span>{shipping.street} {shipping.streetNo}</span>
                        {#if shipping.addInfo && shipping.addInfo !== shipping.company}<span>{shipping.addInfo}</span>{/if}
                        <span>{shipping.zip} {shipping.city}</span>
                        {#if shipping.country}<span>{shipping.country}</span>{/if}
                    {/if}
                </div>
            </div>
            <!-- Billing address -->
            <div class={cardClass} data-checkout-section="address-billing">
                <div class="flex items-center justify-between gap-2">
                    <span class={cardTitleClass}>{t('Rechnungsadresse')}</span>
                    <button class={editLinkClass} onclick={() => onBack('user')} type="button" data-checkout-action="edit-billing">{t('Bearbeiten')}</button>
                </div>
                <div class={cardBodyClass}>
                    {#if billing.company}<span>{billing.company}{#if billing.ustid}&nbsp;({billing.ustid}){/if}</span>{/if}
                    <span>{billing.name}</span>
                    <span>{billing.street} {billing.streetNo}</span>
                    {#if billing.addInfo && billing.addInfo !== billing.company}<span>{billing.addInfo}</span>{/if}
                    <span>{billing.zip} {billing.city}</span>
                    {#if billing.country}<span>{billing.country}</span>{/if}
                </div>
            </div>
        {/if}

        <!-- Versand & Zahlung summary -->
        <div class={cardClass} data-checkout-section="shipping-payment-summary">
            <div class="flex items-center justify-between gap-2">
                <span class={cardTitleClass}>{t('Versand & Zahlung')}</span>
                <button class={editLinkClass} onclick={() => onBack('payment')} type="button" data-checkout-action="edit-payment">{t('Bearbeiten')}</button>
            </div>
            <div class="flex flex-col gap-0.5 text-xsm">
                {#if selectedShipping}
                    <p><span class="font-bold text-[#0a0a0a]">{t('Versandart')}:</span> <span class="text-[#4a5565]">{selectedShipping.shippingSet.title}</span></p>
                {/if}
                {#if selectedPayment}
                    <p><span class="font-bold text-[#0a0a0a]">{t('Zahlungsart')}:</span> <span class="text-[#4a5565]">{isLeasing ? t('Fahrradleasing') : selectedPayment.title}</span></p>
                {/if}
                {#if paymentStore.selectedDeliveryDate}
                    <p data-checkout-section="order-delivery-date" data-option-value={paymentStore.selectedDeliveryDate}>
                        <span class="font-bold text-[#0a0a0a]">{t('Wunsch-Zustelldatum')}:</span> <span class="text-[#4a5565]">{new Date(paymentStore.selectedDeliveryDate).toLocaleDateString(getLocale(), {day:'2-digit', month:'2-digit', year:'numeric'})}</span>
                    </p>
                {/if}
            </div>
            {#if isPaypalAcdc && !placing && !paymentStore.gatewayApproved}
                <div class="-mx-5 -mb-5 mt-2 border-t border-[#e5e7eb] rounded-b-[10px] px-5 pt-3 pb-5">
                    <PaypalAcdc
                        paymentId={selectedPaymentId}
                        metadata={selectedPayment.metadata}
                        onApproved={handlePaypalAcdcApproved}
                        showButton={false}
                        onReady={(api) => acdcApi = api}
                    />
                </div>
            {/if}
            {#if isPaypalPui}
                <div class="-mx-5 -mb-5 mt-2 border-t border-[#e5e7eb] rounded-b-[10px] px-5 pt-3 pb-5">
                    {#key puiReinitKey}
                    <PaypalPui
                        paymentId={selectedPaymentId}
                        metadata={selectedPayment.metadata}
                        initialBirthdate={puiBirthdate}
                        initialPhone={puiPhone}
                        onReady={(bd, ph, cmid) => { puiBirthdate = bd; puiPhone = ph; puiCmid = cmid; }}
                        onClear={() => { puiBirthdate = ''; puiPhone = ''; puiCmid = ''; }}
                    />
                    {/key}
                </div>
            {/if}
        </div>

        <!-- Leasing summary (only when leasing payment selected) -->
        {#if isLeasing}
            <div class={cardClass} data-checkout-section="leasing-summary" data-payment-provider={selectedPayment.metadata?.leasingType?.slug}>
                <div class="flex items-center justify-between gap-2">
                    <span class={cardTitleClass}>{t('Leasing')}</span>
                    <button class={editLinkClass} onclick={() => onBack('payment')} type="button" data-checkout-action="edit-leasing">{t('Bearbeiten')}</button>
                </div>
                <div class={cardBodyClass}>
                    <span class="font-bold text-[#0a0a0a]">{selectedPayment.metadata?.leasingType?.name ?? selectedPayment.title}</span>
                    {#each leasingFormLines as line}
                        <span>{line}</span>
                    {/each}
                </div>
            </div>
        {/if}

        <!-- AGB consent — white card above "Deine Artikel" (deviation from Figma, per request) -->
        <div class={cardClass} data-checkout-section="agb-info">
            <!-- decision: [4] -->
            <div data-checkout-section="eu-notice">
                <EuGuaranteeNotice/>
            </div>
            <!-- reference: [m7_library Utils/i18n 3] -->
            <p class="text-xsm text-[#4a5565] mt-1">{#each teile(t('Ich habe die {agb} und die {widerruf} gelesen und stimme diesen zu.')) as stueck}{#if stueck.platzhalter === 'agb'}<a href="/allgemeine-geschaeftsbedingungen/" target="_blank" class="text-elm underline">{t('AGB')}</a>{:else if stueck.platzhalter === 'widerruf'}<a href="/widerrufsbelehrung/" target="_blank" class="text-elm underline">{t('Widerrufsbelehrung')}</a>{:else}{stueck.text}{/if}{/each}</p>
        </div>


        <!-- Deine Artikel (Figma 419:79) -->
        <div class="bg-white border border-[#e5e7eb] rounded-[10px] shadow-sm p-5 flex flex-col gap-4" data-checkout-section="order-items">
            <span class={cardTitleClass}>{t('Deine Artikel')}</span>
            <div class="flex flex-col">
                {#each basketItems() as item, i (item.id)}
                    <div class="flex gap-4 items-start py-4 border-b border-[#e5e7eb] {i === 0 ? 'border-t' : ''}" data-basket-item={item.id}>
                        <img
                            src={item.image?.default?.src}
                            alt={item.name}
                            class="size-20 rounded-[8px] object-contain shrink-0 bg-white"
                        />
                        <div class="flex-1 min-w-0 flex items-start justify-between gap-3">
                            <div class="flex-1 min-w-0 flex flex-col gap-1">
                                {#if item.brand}<span class="font-bold text-[11px] leading-[15px] uppercase tracking-[1px] text-gray-103">{item.brand}</span>{/if}
                                <span class="font-bold text-xsm leading-[19px] text-[#0a0a0a]">{decodeEntities(item.name)}</span>
                                <span class="font-light text-[11px] leading-[15px] text-gray-103">{t('Menge:')} {item.quantity}</span>
                            </div>
                            <div class="flex flex-col gap-1 items-end shrink-0 text-right">
                                {#if item.regularLineTotal}
                                    <span class="font-light text-[11px] leading-[15px] text-gray-103 line-through whitespace-nowrap">{t('ehem. UVP')} {currencyFormatter.format(item.regularLineTotal)}</span>
                                {/if}
                                <span class="font-bold text-[17px] leading-6 text-cyprus whitespace-nowrap">{currencyFormatter.format(item.lineItemTotal)}</span>
                                {#if item.lineItemSavings > 0}
                                    <span class="font-bold text-[11px] text-scarlet bg-[#fff0ee] rounded-[4px] px-2 py-1 whitespace-nowrap" data-item-savings={item.lineItemSavings}>{t('Du sparst')} {currencyFormatter.format(item.lineItemSavings)}</span>
                                {/if}
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>

        <!-- decision: [3] -->
        {#if userStore.vatValidationResult?.messageStr}
            <div class="rounded-md border px-4 py-3 text-sm flex flex-col gap-2 {vatBlocked ? 'border-amber-400 bg-amber-50' : 'border-green-400 bg-green-50'}" data-checkout-section="vat-validation">
                <p class="{vatBlocked ? 'text-amber-800' : 'text-green-800'}">{userStore.vatValidationResult.messageStr}</p>
                {#if vatBlocked}
                    <label class="flex items-start gap-2 cursor-pointer">
                        <input type="checkbox" bind:checked={vatConfirmed} class="mt-0.5 shrink-0" data-checkout-action="vat-confirm"/>
                        <span class="text-amber-800">{t('Ich möchte die Bestellung trotzdem aufgeben.')}</span>
                    </label>
                {/if}
            </div>
        {/if}

        <div class="flex flex-col gap-3">
            {#if phoneMissingForOrder}
                <PhoneSection onchange={(s) => phoneState = s} data-checkout-section="phone-missing-input"/>
            {/if}

            {#if placeError}
                <div class="text-scarlet text-sm" data-checkout-section="order-error">{placeError}</div>
            {/if}

            {#if paypalAmountFallback}
                <!-- PayPal Express amount-mismatch fallback (#50): the
                     total changed after the Express approve; the backend
                     swapped to standard PayPal. The standard PayPal button
                     renders below (selectedPaymentId = m7_paypal). -->
                <div class="bg-amber-50 border border-amber-300 rounded-lg p-3 text-sm text-amber-900"
                     data-checkout-section="paypal-amount-fallback" role="alert">
                    {t('Der Betrag hat sich geändert. Bitte bestätige die Zahlung erneut über PayPal.')}
                </div>
            {/if}

            <!-- CTA -->
            {#if payerActionUrl && !placing}
                <!-- PayPal Express re-approval (#49): the amount changed
                     (e.g. shipping delta after address); PayPal needs the
                     buyer to re-confirm the same order before capture.
                     Opens PayPal on click — never auto-fires. -->
                <div class="flex flex-col gap-2" data-checkout-section="paypal-reapprove">
                    <p class="text-sm text-gray-700">
                        {t('Der Betrag hat sich geändert. Bitte bestätige die Zahlung erneut bei PayPal, um deinen Kauf abzuschließen.')}
                    </p>
                    <button
                        class={buyBtnClass}
                        onclick={handlePayerActionClick}
                        type="button"
                        data-checkout-action="paypal-reapprove"
                    >
                        {t('Zahlung bei PayPal bestätigen')}
                    </button>
                </div>
            {:else if isPaypalGateway && !placing && !paymentStore.gatewayApproved}
                {#if canOrder}
                    <PaypalGateway
                        paymentId={selectedPaymentId}
                        metadata={selectedPayment.metadata}
                        onApproved={handlePaypalGatewayApproved}
                    />
                {:else}
                    <button
                        class={buyBtnClass}
                        disabled
                        class:opacity-50={true}
                        class:cursor-not-allowed={true}
                        type="button"
                        data-checkout-action="place-order"
                        aria-disabled="true"
                    >{@render lockIcon()}{t('Jetzt kaufen')}</button>
                {/if}
            {:else if isStripe && !placing && !paymentStore.gatewayApproved}
                <StripePayment
                    paymentId={selectedPaymentId}
                    metadata={selectedPayment.metadata}
                    {canOrder}
                    {buyBtnClass}
                    {cardClass}
                    onApproved={handleStripeApproved}
                />
            {:else if isAmazonPay && !placing && !paymentStore.gatewayApproved}
                <AmazonPay
                    paymentId={selectedPaymentId}
                    metadata={selectedPayment.metadata}
                />
            {:else if isPaypalAcdc && !placing && !paymentStore.gatewayApproved}
                <button
                    class={buyBtnClass}
                    disabled={!canOrder || !acdcApi}
                    class:opacity-50={!canOrder || !acdcApi}
                    class:cursor-not-allowed={!canOrder || !acdcApi}
                    onclick={() => acdcApi?.submit()}
                    type="button"
                    data-checkout-action="place-order"
                    aria-disabled={!(canOrder && !!acdcApi)}
                >
                    {@render lockIcon()}{t('Jetzt kaufen')}
                </button>
            {:else if !isPaypalAcdc || paymentStore.gatewayApproved}
                <button
                    class={buyBtnClass}
                    disabled={!canOrder}
                    class:opacity-50={!canOrder}
                    class:cursor-not-allowed={!canOrder}
                    onclick={handlePlaceOrder}
                    type="button"
                    data-checkout-action="place-order"
                    aria-disabled={!canOrder}
                >
                    {#if !placing}{@render lockIcon()}{/if}{placing ? t('Bestellung wird aufgegeben…') : t('Jetzt kaufen')}
                </button>
            {/if}
        </div>

    </div>
{/if}

{#snippet lockIcon()}
    <svg class="shrink-0 size-4.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
{/snippet}
